import { Injectable } from '@angular/core';
import { tokenNotExpired } from 'angular2-jwt';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import {from} from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { IApiResult } from '../../models/IApiResult';
import { Router } from '@angular/router';
// import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Alert } from 'selenium-webdriver';
import * as Cookie from 'js-cookie';
// import { Http } from '@angular/http';
import { Http, Headers } from '@angular/http';
import { LoginResult } from '../../models/LoginResult';



@Injectable()
export class AuthService {
  redirectUrl: string;
  isIEOrEdge: boolean;
//  loTransientReq: TransientAuthenticateDto;

  constructor(
    private router: Router, 	private http: HttpClient) {
    this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  }

  loggedIn() {

    if (this.isIEOrEdge) {
      // alert(Cookie.get('token'));
      // alert(tokenNotExpired(null, Cookie.get('token')));
      return tokenNotExpired(null, Cookie.get('token'));
    } else {

      // alert(Cookie.get('token'));
      // alert('tokenNotExpired(null)' + tokenNotExpired(null, Cookie.get('token')));

      // alert('tokenNotExpired()' + tokenNotExpired());
      return tokenNotExpired();
    }
  }


  logOut() {
    if (this.isIEOrEdge) {
      Cookie.remove('searchText');
      if (Cookie.get('displayUserInfo') !== undefined) {
        Cookie.remove('displayUserInfo');
      }
      Cookie.remove('token');

    //  alert('removed token');
    } else {
      localStorage.clear();
    }

    if ((this.router.url.indexOf('/pages/changepwd') < 0 ) && (this.router.url.indexOf('/pages/transient' ) < 0)
     && (this.router.url.indexOf('/pages/ConfirmEmail' ) < 0)
    ) {

   // this.router.navigate(['/pages/login']);
    }

  }


getTransientUrl(userguid: string, destinationAppId: string, bearerToken: string): Observable<string> {
return this.http.post<TransientResponseDto>('api/Login/GetTransientUrl', {
userId: userguid,
destinationApplicationId: destinationAppId,
bearerToken: bearerToken
}).pipe(
  map((response: TransientResponseDto) => response.url   ) ,
  catchError((x: HttpErrorResponse) => {
   // alert('error' + x.message);
    const model = x.status === 401 ? { unauthorized: true } : { badRequest: true };
    return of(null);
  })
);
}

getImpersonateMYJSSIuser(userguid: string,  bearerToken: string, Email: string): Observable<string> {
  return this.http.post<TransientResponseDto>('api/Login/getImpersonateMYJSSIuser', {
  userId: userguid,
  bearerToken: bearerToken,
  email: Email
  }).pipe(
    map((response: TransientResponseDto) => response.url   ) ,
    catchError((x: HttpErrorResponse) => {
     // alert('error' + x.message);
      const model = x.status === 401 ? { unauthorized: true } : { badRequest: true };
      return of(null);
    })
  );
  }

// authenticateTransientUser(userguid: string, authToken: string): Observable<LoginResult> {
//   return this.processLogin('/api/authentication/token/authenticate-transient', {
//     userId: userguid,
//     authenticateToken: authToken
//   }, '');
// }
// }


authenticateTransientUser(userguid: string, authToken: string, pbisimpersonate: boolean,
  Email: string ,
  FirstName: string ,
    LastName: string
  ) {

  return this.http.post<LoginResult>('api/Login/AuthenticateTransient', {
    userId: userguid,
    authenticateToken: authToken,
    isimpersonate: pbisimpersonate,
    Email: Email,
    FirstName: FirstName,
    LastName: LastName
    //,
  //  bearerToken: bearerToken
    }).pipe(
      map((response: LoginResult) => response   ) ,
      catchError((x: HttpErrorResponse) => {
       // alert('error' + x.message);
        const model = x.status === 401 ? { unauthorized: true } : { badRequest: true };
        return of(null);
      })
    );
    }
    authenticateConfrimEmailUser(userguid: string, authToken: string, LID: string) {

      return this.http.post<LoginResult>('api/Login/authenticateConfrimEmailUser', {
        userId: userguid,
        authenticateToken: authToken ,
        LID: LID
        }).pipe(
          map((response: LoginResult) => response   ) ,
          catchError((x: HttpErrorResponse) => {
           // alert('error' + x.message);
            const model = x.status === 401 ? { unauthorized: true } : { badRequest: true };
            return of(null);
          })
        );
        }
}


export class TransientResponseDto {
  url: string;
  expiration?: Date;
  }

  export class TransientAuthenticateDto {
   userId: string ;
    authenticateToken: string ;
    isimpersonate: boolean;
    Email: string ;
      FirstName: string ;
        LastName: string ;
  }



// WEBPACK FOOTER //
// ./src/app/services/auth/auth.service.ts